import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { ExpensesPage } from './pages/ExpensesPage';
import { EXPENSE_TABS } from './expenses.paths';

export const EXPENSE_ROUTES: RouteObject[] = recordTabRoutes('expenses', EXPENSE_TABS, (tab) => <ExpensesPage tab={tab} />);
